var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('h2',{staticClass:"size18 bold i-block"},[_vm._v(_vm._s(_vm.$t('Спасибо'))+"! Ваша заявка на "+_vm._s(_vm.orderName)+" "+_vm._s(_vm.$t('принята')))]),_c('div',{staticClass:"num-request"},[_vm._v("Заявка № "),_c('strong',[_vm._v(_vm._s(_vm.orderId))])]),_c('div',[_vm._v(_vm._s(_vm.$t('с Вами свяжется менеджер')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }